import { Badge, Button, CircularProgress } from "@mui/material";
import Sort from "../../assets/sort.svg";
import { purple, purpleLight, black } from "../../theme/colors";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  color: black,
  borderColor: "#ECECEC",
  borderRadius: 2,
  px: 1.5,
  whiteSpace: "nowrap",
  "&:hover": { borderColor: purple, bgcolor: purpleLight },
} as const;

export function ToolbarButton({
  icon,
  label,
  onClick,
  badgeCount,
  loading = false,
  disabled = false,
}: {
  icon: string;
  label: string;
  onClick?: () => void;
  badgeCount?: number | null;
  loading?: boolean;
  disabled?: boolean;
}) {
  const button = (
    <Button
      onClick={onClick}
      variant="outlined"
      disabled={disabled}
      startIcon={
        loading ? (
          <CircularProgress size={16} sx={{ color: purple }} />
        ) : (
          <img src={icon} width={16} height={16} alt="" />
        )
      }
      sx={buttonSx}
    >
      {label}
    </Button>
  );
  return badgeCount ? (
    <Badge
      badgeContent={badgeCount}
      color="primary"
      overlap="circular"
      sx={{ "& .MuiBadge-badge": { fontSize: "0.7rem", height: 16, minWidth: 16 } }}
    >
      {button}
    </Badge>
  ) : (
    button
  );
}

export function SortToggle({
  ascending,
  onToggle,
}: {
  ascending: boolean;
  onToggle: () => void;
}) {
  return (
    <Button
      onClick={onToggle}
      variant="outlined"
      startIcon={<img src={Sort} width={16} height={16} alt="" />}
      sx={buttonSx}
    >
      {ascending ? "New to old" : "Old to new"}
    </Button>
  );
}
